import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Dashboard } from '@/components/Dashboard';
import { Upload } from '@/components/Upload';
import { Layout } from '@/components/Layout';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="upload" element={<Upload />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
